import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  UiStatusFactsService,
} from './ui-status.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule
  ],
  providers: [
    UiStatusFactsService
  ]
})
export class UiStatusFactsModule {}
